import React from 'react';
import { motion } from 'framer-motion';
import { Hammer, ShieldCheck, FileText } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-gradient-to-b from-dark-50 to-dark-DEFAULT border-y border-gold/20" data-id="element-159">
      <div className="max-w-6xl mx-auto px-4" data-id="element-160">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-162">
            <h2 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6" data-id="element-163">
              INTRODUCING THE <br data-id="element-164" />
              <span className="text-gold" data-id="element-165">SLEDGEHAMMER</span>
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-166">
              This isn't a "dispute letter." It's a procedural demand for
              physical verification. By citing specific federal statutes, we
              force a human being to physically locate your original contract.
            </p>

            <div className="space-y-6" data-id="element-167">
              {['Bypasses the e-OSCAR automated rejection system', 'Demands physical proof of the original signed contract', "Forces deletion if they cannot provide the proof (they usually can't)", 'Works on collections, charge-offs, late payments, and inquiries'].map((item, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-168">
                  <div className="mt-1 bg-gold/20 p-1 rounded-full" data-id="element-169">
                    <Hammer className="w-5 h-5 text-gold" data-id="element-170" />
                  </div>
                  <p className="text-white font-medium" data-id="element-171">{item}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-172">
            <div className="absolute inset-0 bg-gold/10 blur-3xl rounded-full" data-id="element-173"></div>
            <div className="relative bg-dark-100 border border-gold/30 p-8 rounded-xl shadow-2xl" data-id="element-174">
              <div className="flex items-center gap-4 mb-6 border-b border-gray-700 pb-4" data-id="element-175">
                <FileText className="w-8 h-8 text-gold" data-id="element-176" />
                <div data-id="element-177">
                  <h3 className="text-xl font-heading font-bold text-white" data-id="element-178">
                    The 609 Sledgehammer Template
                  </h3>
                  <p className="text-sm text-gray-400" data-id="element-179">Certified Mail Format</p>
                </div>
              </div>
              <div className="space-y-3 font-mono text-sm text-gray-400 opacity-80" data-id="element-180">
                <div className="h-4 bg-gray-700 rounded w-3/4" data-id="element-181"></div>
                <div className="h-4 bg-gray-700 rounded w-1/2" data-id="element-182"></div>
                <div className="h-4 bg-gray-700 rounded w-full" data-id="element-183"></div>
                <div className="h-4 bg-gray-700 rounded w-full" data-id="element-184"></div>
                <div className="h-4 bg-gray-700 rounded w-2/3" data-id="element-185"></div>
                <div className="p-4 bg-red-900/20 border border-red-900/50 rounded mt-4 text-red-400" data-id="element-186">
                  "Pursuant to Section 609(a)(1)(A), you are required by federal
                  law to verify..."
                </div>
              </div>
              <div className="mt-6 flex justify-center" data-id="element-187">
                <div className="bg-gold text-dark-DEFAULT font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-188">
                  High Priority Document
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}